import Resource from './common/resource';
import defaultBanners from '@/data/banners';

const BANNERS_FOLDER_ID = 'banners';
const CDN_BASE = 'https://throwbocdn.s3.amazonaws.com/banners/';

class FileFolders extends Resource {
  path = 'files/folders';

  onLoad({ commit }, { res }) {
    const files = Array.isArray(res?.data) ? [...res.data] : [];
    files.unshift(createBannersFolder());
    commit('setAll', files);
  }
}

function createBannersFolder() {
  return {
    id: BANNERS_FOLDER_ID,
    name: 'Stock Banners',
    type: 'folder',
    system: true,
    files_count: defaultBanners.length,
    files: defaultBanners.map((name, idx) => createBanner(name, idx)),
  };
}

function createBanner(name, idx) {
  const url = bannerUrl(name);
  return {
    id: `banner-${idx}`,
    cdn: url,
    extension: 'jpg',
    filename: name,
    mimetype: 'image/jpeg',
    folder_id: BANNERS_FOLDER_ID,
    system: true,
    type: 'banner',
    url,
  };
}

const bannerUrl = (src) => (src.startsWith('http') ? src : `${CDN_BASE}${src}`);

export default FileFolders;
